class omrFacets extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('facet:render', (e)=> {
      let filterSelectedCount = parseInt(e.detail.url.searchParams.size) - 1;
      this.dispatchEvent(new CustomEvent('filterSelected:update', {
        detail: {
          filterSelectedCount: filterSelectedCount
        },
        bubbles: true,
      }));
    })
  }
}

customElements.define('omr-facets', omrFacets);

class omrFilterSelected extends HTMLElement {
  constructor() {
    super();
    this.countSelected = this.querySelector('[data-count-selected]');
    this.item_selecteds = document.querySelectorAll('omr-facets input[type="checkbox"]:checked');
  
    this.updateCountSelected(this.item_selecteds.length || 0);
    document.addEventListener('filterSelected:update', (e)=> {
      this.updateCountSelected(e.detail.filterSelectedCount);
    })
  }
  connectedCallback() {
    
  }
  updateCountSelected(count) {
    if(count === 0){
      this.countSelected.innerHTML = `Aucun`;
      this.classList.remove('filter-selected');
    }else{
      this.countSelected.innerHTML = `${count}`;
      this.classList.add('filter-selected');
    }

  }
}

customElements.define('omr-filter-selected', omrFilterSelected);


class omrBundleEl extends HTMLElement {
  constructor() {
    super();
    this.bundle_section_url = this.dataset.currentUrl;
    this.is_bundle = parseInt(this.dataset.isBundle);
    this.cta = this.querySelector('a');
    let bundle_section = document.querySelector('#omr-bundles-product-list');

    if(bundle_section && this.is_bundle == 1){
      this.cta.href = `${this.bundle_section_url}#${bundle_section.id}`;
    }
    this.cta.addEventListener('click', (e) => {
      this.cta.classList.add('is-active');
    })
  }
}

customElements.define('omr-bundle-el', omrBundleEl);

// Omr slider

// Omr video player
class omrVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
  }
  connectedCallback(){
    this.button.addEventListener('click', (e)=>{
      e.preventDefault();
      this.video.play();
      this.video.controls = true;
      this.button.classList.add('hdt-hidden');
    });
    this.waitForVideo(this.video).then(()=>{
      this.button.classList.remove('hdt-hidden');
    });
  }
  waitForVideo(video) {
    return new Promise((resolve) => {
      if (video.readyState >= 4) return resolve(video);
      video.addEventListener('canplaythrough', () => resolve(video), { once: true });
    });
  }
}

customElements.define('omr-video-player', omrVideoPlayer);


class omrPublicQuote extends HTMLElement {
  constructor() {
    super();
    this.marquee = this.querySelector('hdt-marquee');
    this.isInViewport = false;
    this.animationFrameId = null;
    this._isPlay = false;

  }
  connectedCallback(){
    const targetElement = this;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.5]
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if(!this._isPlay) {
            this.playMarquee();
          }
          this._isPlay = true;
        } else {
          if(this._isPlay) {
            this.pauseMarquee();
          }
          this._isPlay = false;
        }
      });
    }, options);

    observer.observe(targetElement);
  }
  playMarquee() {
    this.marquee.dispatchEvent(new Event('mouseleave'));
  }
  pauseMarquee() {
    this.marquee.dispatchEvent(new Event('mouseenter'));
  }

  disconnectedCallback() {
    this.stopContinuousCheck();
  }
}

customElements.define('omr-public-quote', omrPublicQuote);


document.addEventListener('DOMContentLoaded', function() {
        
  const accordionHeaders = document.querySelectorAll('.it-header');

  accordionHeaders.forEach(header => {
      
      header.addEventListener('click', function() {
          
          const accordionItem = this.parentElement;
          
          accordionItem.classList.toggle('it-active');
          
          /* 
          closeOtherItems(accordionItem);
          */
      });
  });
  function closeOtherItems(currentItem) {
      const allItems = document.querySelectorAll('.accordion-item');
      allItems.forEach(item => {
          if (item !== currentItem) {
              item.classList.remove('active');
          }
      });
  }
});